import { RightOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import posthog from 'posthog-js';
import { usePushNotificationOptIn } from 'push/PushNotificationOptInContext';
import { createUseStyles } from 'react-jss';
import { useNavigate } from 'react-router-dom';
import { routes } from 'services/RouteService';
import Platform from 'utils/Platform';

export type NotificationSuggesterProps = {
  text: string;
};

const useStyles = createUseStyles({
  warningContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  arrowIcon: {
    fontSize: '0.7em',
  },
});

const NotificationSuggester: React.FC<NotificationSuggesterProps> = ({ text }) => {
  const styles = useStyles();
  const navigate = useNavigate();
  const { enableNotifications } = usePushNotificationOptIn();

  return (
    <Alert
      message={
        <div className={styles.warningContent}>
          <div>{text}</div>
          <div className={styles.arrowIcon}>
            <RightOutlined />
          </div>
        </div>
      }
      type="warning"
      onClick={() => {
        posthog.capture('notification_suggester_clicked');
        if (!Platform.isNative()) {
          navigate(routes.settings.route);
        } else {
          enableNotifications();
        }
      }}
    />
  );
};
export default NotificationSuggester;
